import axios from "axios";
import { API_BASE_URL } from "../Constant";

/* -- Start of Axios Interceptors for Data Apis -- */
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

/* Api request to fetch the data */
export const dataDisplayRequest = async (config) => {
  return await axiosInstance.request(config).then(function (response) {
    return Promise.resolve(response);
  });
};
